module.exports = __webpack_public_path__ + "assets/img/D3-Security-Content-Marketing.ab7a1272.jpg";